// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.export-button-container {
  position: relative;
  display: inline-block;
}

/* Main Export Button */
.export-button {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-secondary);
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
  height: 36px;
}

.export-button:hover:not(.disabled) {
  background: var(--bg-tertiary);
  border-color: var(--border-primary);
  color: var(--text-primary);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.export-button.active {
  background: var(--accent-primary);
  border-color: var(--accent-primary);
  color: white;
}

.export-button.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.export-button.success {
  background: #10B981;
  border-color: #10B981;
  color: white;
}

.export-button.error {
  background: #EF4444;
  border-color: #EF4444;
  color: white;
}

.export-text {
  font-weight: 500;
}

/* Spinning animation for loading state */
.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Export Dropdown */
.export-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: var(--bg-primary);
  border: 1px solid var(--border-secondary);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  min-width: 280px;
  z-index: 1000;
  overflow: hidden;
  animation: dropdownSlideIn 0.2s ease-out;
}

@keyframes dropdownSlideIn {
  from {
    opacity: 0;
    transform: translateY(-8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Dark theme shadow */
[data-theme="dark"] .export-dropdown {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}

/* Dropdown Header */
.export-dropdown-header {
  padding: 16px 20px 12px 20px;
  border-bottom: 1px solid var(--border-tertiary);
}

.export-dropdown-header h4 {
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}

.export-dropdown-header p {
  margin: 0;
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.4;
}

/* Format List */
.export-format-list {
  padding: 0;
}

.export-format-button {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  border: none;
  background: none;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}

.export-format-button:hover:not(:disabled) {
  background: var(--bg-secondary);
}

.export-format-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.format-icon {
  width: 40px;
  height: 40px;
  background: var(--bg-secondary);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  flex-shrink: 0;
}

.export-format-button:hover:not(:disabled) .format-icon {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.format-info {
  flex: 1 1;
  min-width: 0;
}

.format-name {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: 2px;
}

.format-description {
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.3;
}
.export-format-section {
  padding: 16px 20px 8px 20px;
}

.export-format-section h5 {
  margin: 0 0 12px 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}


.format-extension {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-tertiary);
  background: var(--bg-tertiary);
  padding: 4px 8px;
  border-radius: 4px;
  flex-shrink: 0;
}

.export-format-button:hover:not(:disabled) .format-extension {
  background: var(--accent-primary);
  color: white;
}

/* Export Type Selection Section */
.export-type-section {
  padding: 16px 20px 8px 20px;
  border-bottom: 1px solid var(--border-tertiary);
}

.export-type-section h5 {
  margin: 0 0 12px 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.export-type-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.export-type-button {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border: 2px solid var(--border-secondary);
  border-radius: 8px;
  background: var(--bg-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  color: var(--text-primary); /* ADD THIS */
}

.export-type-button:hover:not(:disabled) {
  border-color: var(--accent-primary);
  background: var(--bg-tertiary);
  color: var(--text-primary); /* ADD THIS */
}

.export-type-button.active {
  border-color: var(--accent-primary);
  background: var(--accent-primary);
  color: white !important; /* MAKE THIS IMPORTANT */
}

.export-type-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.type-info {
  flex: 1 1;
}

.type-name {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 2px;
  color: inherit; /* ADD THIS */
}

.type-description {
  font-size: 12px;
  opacity: 0.8;
  line-height: 1.3;
  color: inherit; /* ADD THIS */
}

/* Remove the separate active state color rules since we use inherit now */
.export-type-button.active .type-name,
.export-type-button.active .type-description {
  color: inherit; /* CHANGE THIS TO INHERIT */
}

/* Format Section Updates */
.export-format-section {
  padding: 16px 20px 8px 20px;
}

.export-format-section h5 {
  margin: 0 0 12px 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.export-format-list {
  padding: 0;
}

/* Focus states for accessibility */
.export-type-button:focus-visible {
  outline: 2px solid var(--accent-primary);
  outline-offset: 2px;
}

/* Dropdown Footer */
.export-dropdown-footer {
  padding: 8px 20px 16px 20px;
  border-top: 1px solid var(--border-tertiary);
}

.export-dropdown-footer span {
  font-size: 11px;
  color: var(--text-tertiary);
  font-style: italic;
}

/* Export Status */
.export-status {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  z-index: 1001;
  animation: statusSlideIn 0.2s ease-out;
}

.export-status.success {
  background: #10B981;
  color: white;
}

.export-status.error {
  background: #EF4444;
  color: white;
}

@keyframes statusSlideIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .export-dropdown {
    right: -40px;
    left: -40px;
    width: auto;
    min-width: unset;
  }
  
   .export-format-button {
    padding: 16px 20px;
  }
  
  .format-icon {
    width: 36px;
    height: 36px;
  }

  .export-button {
    padding: 6px 12px; 
    font-size: 13px; 
  }
  
  /* .export-text {
    display: none;
  } */
}

/* Focus states for accessibility */
.export-button:focus-visible {
  outline: 2px solid var(--accent-primary);
  outline-offset: 2px;
}

.export-format-button:focus-visible {
  outline: 2px solid var(--accent-primary);
  outline-offset: -2px;
}`, "",{"version":3,"sources":["webpack://./src/styles/ExportButton.css"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,0BAA0B;EAC1B,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,6BAA6B;EAC7B,yCAAyC;EACzC,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,sBAAsB;AACtB;EACE,yCAAyC;AAC3C;;AAEA,oBAAoB;AACpB;EACE,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B,EAAE,aAAa;AAC3C;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,0BAA0B,EAAE,aAAa;AAC3C;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,uBAAuB,EAAE,wBAAwB;AACnD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc,EAAE,aAAa;AAC/B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc,EAAE,aAAa;AAC/B;;AAEA,0EAA0E;AAC1E;;EAEE,cAAc,EAAE,2BAA2B;AAC7C;;AAEA,2BAA2B;AAC3B;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA,mCAAmC;AACnC;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,WAAW;IACX,WAAW;IACX,gBAAgB;EAClB;;GAEC;IACC,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;KAEG;AACL;;AAEA,mCAAmC;AACnC;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;AACtB","sourcesContent":["\n.export-button-container {\n  position: relative;\n  display: inline-block;\n}\n\n/* Main Export Button */\n.export-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-secondary);\n  border-radius: 8px;\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  height: 36px;\n}\n\n.export-button:hover:not(.disabled) {\n  background: var(--bg-tertiary);\n  border-color: var(--border-primary);\n  color: var(--text-primary);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.export-button.active {\n  background: var(--accent-primary);\n  border-color: var(--accent-primary);\n  color: white;\n}\n\n.export-button.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.export-button.success {\n  background: #10B981;\n  border-color: #10B981;\n  color: white;\n}\n\n.export-button.error {\n  background: #EF4444;\n  border-color: #EF4444;\n  color: white;\n}\n\n.export-text {\n  font-weight: 500;\n}\n\n/* Spinning animation for loading state */\n.spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Export Dropdown */\n.export-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 8px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-secondary);\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n  min-width: 280px;\n  z-index: 1000;\n  overflow: hidden;\n  animation: dropdownSlideIn 0.2s ease-out;\n}\n\n@keyframes dropdownSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-8px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* Dark theme shadow */\n[data-theme=\"dark\"] .export-dropdown {\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);\n}\n\n/* Dropdown Header */\n.export-dropdown-header {\n  padding: 16px 20px 12px 20px;\n  border-bottom: 1px solid var(--border-tertiary);\n}\n\n.export-dropdown-header h4 {\n  margin: 0 0 4px 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.export-dropdown-header p {\n  margin: 0;\n  font-size: 13px;\n  color: var(--text-secondary);\n  line-height: 1.4;\n}\n\n/* Format List */\n.export-format-list {\n  padding: 0;\n}\n\n.export-format-button {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 20px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n}\n\n.export-format-button:hover:not(:disabled) {\n  background: var(--bg-secondary);\n}\n\n.export-format-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.format-icon {\n  width: 40px;\n  height: 40px;\n  background: var(--bg-secondary);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-secondary);\n  flex-shrink: 0;\n}\n\n.export-format-button:hover:not(:disabled) .format-icon {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.format-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.format-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n  margin-bottom: 2px;\n}\n\n.format-description {\n  font-size: 12px;\n  color: var(--text-secondary);\n  line-height: 1.3;\n}\n.export-format-section {\n  padding: 16px 20px 8px 20px;\n}\n\n.export-format-section h5 {\n  margin: 0 0 12px 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n\n.format-extension {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-tertiary);\n  background: var(--bg-tertiary);\n  padding: 4px 8px;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n\n.export-format-button:hover:not(:disabled) .format-extension {\n  background: var(--accent-primary);\n  color: white;\n}\n\n/* Export Type Selection Section */\n.export-type-section {\n  padding: 16px 20px 8px 20px;\n  border-bottom: 1px solid var(--border-tertiary);\n}\n\n.export-type-section h5 {\n  margin: 0 0 12px 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.export-type-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.export-type-button {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  border: 2px solid var(--border-secondary);\n  border-radius: 8px;\n  background: var(--bg-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n  color: var(--text-primary); /* ADD THIS */\n}\n\n.export-type-button:hover:not(:disabled) {\n  border-color: var(--accent-primary);\n  background: var(--bg-tertiary);\n  color: var(--text-primary); /* ADD THIS */\n}\n\n.export-type-button.active {\n  border-color: var(--accent-primary);\n  background: var(--accent-primary);\n  color: white !important; /* MAKE THIS IMPORTANT */\n}\n\n.export-type-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.type-info {\n  flex: 1;\n}\n\n.type-name {\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 2px;\n  color: inherit; /* ADD THIS */\n}\n\n.type-description {\n  font-size: 12px;\n  opacity: 0.8;\n  line-height: 1.3;\n  color: inherit; /* ADD THIS */\n}\n\n/* Remove the separate active state color rules since we use inherit now */\n.export-type-button.active .type-name,\n.export-type-button.active .type-description {\n  color: inherit; /* CHANGE THIS TO INHERIT */\n}\n\n/* Format Section Updates */\n.export-format-section {\n  padding: 16px 20px 8px 20px;\n}\n\n.export-format-section h5 {\n  margin: 0 0 12px 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.export-format-list {\n  padding: 0;\n}\n\n/* Focus states for accessibility */\n.export-type-button:focus-visible {\n  outline: 2px solid var(--accent-primary);\n  outline-offset: 2px;\n}\n\n/* Dropdown Footer */\n.export-dropdown-footer {\n  padding: 8px 20px 16px 20px;\n  border-top: 1px solid var(--border-tertiary);\n}\n\n.export-dropdown-footer span {\n  font-size: 11px;\n  color: var(--text-tertiary);\n  font-style: italic;\n}\n\n/* Export Status */\n.export-status {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 4px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  z-index: 1001;\n  animation: statusSlideIn 0.2s ease-out;\n}\n\n.export-status.success {\n  background: #10B981;\n  color: white;\n}\n\n.export-status.error {\n  background: #EF4444;\n  color: white;\n}\n\n@keyframes statusSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .export-dropdown {\n    right: -40px;\n    left: -40px;\n    width: auto;\n    min-width: unset;\n  }\n  \n   .export-format-button {\n    padding: 16px 20px;\n  }\n  \n  .format-icon {\n    width: 36px;\n    height: 36px;\n  }\n\n  .export-button {\n    padding: 6px 12px; \n    font-size: 13px; \n  }\n  \n  /* .export-text {\n    display: none;\n  } */\n}\n\n/* Focus states for accessibility */\n.export-button:focus-visible {\n  outline: 2px solid var(--accent-primary);\n  outline-offset: 2px;\n}\n\n.export-format-button:focus-visible {\n  outline: 2px solid var(--accent-primary);\n  outline-offset: -2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
